import { render, staticRenderFns } from "./viewModal.vue?vue&type=template&id=4ffa6ccd&scoped=true&"
import script from "./viewModal.vue?vue&type=script&lang=js&"
export * from "./viewModal.vue?vue&type=script&lang=js&"
import style0 from "./viewModal.vue?vue&type=style&index=0&id=4ffa6ccd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffa6ccd",
  null
  
)

export default component.exports